﻿import LegendControl from './controls/general/LegendControl';
import TemporaryEditControl from './controls/TemporaryEditControl';
import * as actionTypes from './utils/actionTypes';
import * as eventTypes from '../map/utils/eventTypes';
import ChartControl from './controls/chart/ChartControl';
import ZoomControl from './controls/general/ZoomControl';
import ScaleControl from './controls/general/ScaleControl';
import MousePositionControl from './controls/general/MousePositionControl';
import CoordinateReferenceSystemSwitcherControl from './controls/general/CoordinateReferenceSystemSwitcherControl';
import NavigationToolbarControl from './controls/general/NavigationToolbarControl';
import SelectionToolbarControl from './controls/general/SelectionToolbarControl';
import ExportToolbarControl from './controls/general/ExportToolbarControl';
import GeolocationControl from './controls/general/GeolocationControl';
import MeasurementControl from './controls/general/MeasurementControl';
import RedlineControl from './controls/general/RedlineControl';
import DimensioningControl from './controls/general/DimensioningControl';
import JoinAnalysisControl from './controls/general/JoinAnalysisControl';
import BufferAnalysisControl from './controls/general/BufferAnalysisControl';
import PrintingControl from './controls/general/PrintingControl';
import SpatialSearchControl from './controls/general/SpatialSearchControl';
import EditControl from './controls/EditControl';
import QuickAddControl from './controls/general/QuickAddControl';
import QuickSearchControl from './controls/general/QuickSearchControl';
import SnapControl from './controls/general/SnapControl';
import SwipeControl from './controls/general/SwipeControl';
import TimelineControl from './controls/general/TimelineControl';
import OverviewControl from './controls/general/OverviewControl';

export default class GeneralActionHandler {
    constructor(generalActionSettingsHandler, resourcesHandler, layerSettingsHandler, mapContainer, mapId, rootURL, classId, styleHandler, mapControl) {
        this.generalActionSettingsHandler = generalActionSettingsHandler;
        this.resourcesHandler = resourcesHandler;
        this.layerSettingsHandler = layerSettingsHandler;
        this.mapContainer = mapContainer;
        this.mapId = mapId;
        this.classId = classId;
        this.rootURL = rootURL;
        this.styleHandler = styleHandler;
        this.containerId = 'xpmap-' + mapId + '-' + this.classId;
        this.mapMenuElementId = 'xpmap-menu-' + mapId + '-' + this.classId;
        this.chartsWrapper = 'xpmap-charts-wrapper-' + mapId + '-' + this.classId;
        this.actionWrapper = 'xpmap-action-wrapper-' + mapId + '-' + this.classId;
        this.zoomWrapper = 'xpmap-zoom-wrapper-' + mapId + '-' + this.classId;
        this.scaleWrapper = 'xpmap-scale-wrapper-' + mapId + '-' + this.classId;
        this.mousePositionWrapper = 'xpmap-mouse-position-wrapper-' + mapId + '-' + this.classId;
        this.crsSwitcherWrapper = 'xpmap-crs-switcher-wrapper-' + mapId + '-' + this.classId;
        this.navigationToolbarWrapper = 'xpmap-navigation-toolbar-wrapper-' + mapId + '-' + this.classId;
        this.selectionToolbarWrapper = 'xpmap-selection-toolbar-wrapper-' + mapId + '-' + this.classId;
        this.spatialSearchWrapper = 'xpmap-spatial-search-wrapper-' + mapId + '-' + this.classId;
        this.exportToolbarWrapper = 'xpmap-export-toolbar-wrapper-' + mapId + '-' + this.classId;
        this.featureToolbarWrapper = 'xpmap-feature-toolbar-wrapper-' + mapId + '-' + this.classId;
        this.swipeWrapper = 'xpmap-swipe-wrapper-' + mapId + '-' + this.classId;
        this.snapToolbarWrapper = 'xpmap-snap-toolbar-wrapper-' + mapId + '-' + this.classId;
        this.timelineWrapper = 'xpmap-timeline-wrapper-' + mapId + '-' + this.classId;
        this.mapMenuElementListId = this.mapMenuElementId + '-list';
        this.generalActionControls = {};
        this.pluginControls = {};
        this.chartControl = null;
        this.mapControl = mapControl;
        this.featureEditorControl = null;
        this.quickAddLayers = [];
        this.addLayers = [];
        this.multipleAddLayers = [];
        this.quickSearches = [];
    }

    init() {
        if (this.mapControl.generalSettingsHandler.settings
            && this.mapControl.generalSettingsHandler.settings.QuickSearchConfig
            && this.mapControl.generalSettingsHandler.settings.QuickSearchConfig.trim() != '') {
            this.quickSearches = JSON.parse(this.mapControl.generalSettingsHandler.settings.QuickSearchConfig);
            if (this.quickSearches.length > 0) {
                this.generalActionControls.quickSearchControl = new QuickSearchControl(this.resourcesHandler, this.layerSettingsHandler, $("#" + this.containerId).parent(), this.rootURL, this.classId, this.mapControl, this.quickSearches);
                this.generalActionControls.quickSearchControl.init();
            }
        }

        if (this.generalActionSettingsHandler.settings && this.generalActionSettingsHandler.settings.length > 0) {
            this.mapContainer.append(this._getActionListTemplate());
            this.mapContainer.append(this._getChartWrapper());
            this.mapContainer.append(this._getActionWrapper());
            this.mapContainer.append(this._getZoomWrapper());
            this.mapContainer.append(this._getScaleWrapper());
            this.mapContainer.append(this._getMousePositionWrapper());
            this.mapContainer.append(this._getCrsSwitcherWrapper());
            this.mapContainer.append(this._getNavigationToolbarWrapper());
            this.mapContainer.append(this._getSelectionToolbarWrapper());
            this.mapContainer.append(this._getExportToolbarWrapper());
            this.mapContainer.append(this._getFeatureToolbarWrapper());
            this.mapContainer.append(this._getSwipeWrapper());
            this.mapContainer.append(this._getSnapToolbarWrapper());
            this.mapContainer.append(this._getTimelineWrapper());
            this.chartControl = new ChartControl(this.rootURL, document.getElementById(this.chartsWrapper), this.resourcesHandler, this.layerSettingsHandler);
            this.generalActionControls.editControl = new EditControl(this.resourcesHandler, this.layerSettingsHandler, document.getElementById(this.mapMenuElementListId), this.rootURL, this.classId, this.mapControl, document.getElementById(this.featureToolbarWrapper));

            this.addLayers = this.generalActionSettingsHandler.settings.filter(x => {
                if (x.SubType == actionTypes.SUBTYPE_ADD) {
                    return true;
                }
                return false;
            });

            this.multipleAddLayers = this.generalActionSettingsHandler.settings.filter(x => {
                if (x.SubType == actionTypes.SUBTYPE_ADD_MULTI) {
                    return true;
                }
                return false;
            });

            this.quickAddLayers = this.addLayers.filter(x => {
                if (x.Content != null && x.Content.trim() != '') {
                    let content = JSON.parse(x.Content.trim());
                    if (content.showInQuickLegend) {
                        return true;
                    }
                }
                return false;
            });

            if (this.quickAddLayers.length > 0) {
                this.generalActionSettingsHandler.settings.push({
                    Id: this.quickAddLayers[0].Id,
                    Icon: "fal fa-plus-hexagon",
                    Text: actionTypes.SUBTYPE_QUICK_ADD,
                    Title: actionTypes.SUBTYPE_QUICK_ADD,
                    SubType: actionTypes.SUBTYPE_QUICK_ADD,
                    Type: actionTypes.TYPE_STANDARD_GENERAL
                });
            }

            this.generalActionSettingsHandler.settings.forEach(generalAction => {
                if (generalAction.Id != 0 || generalAction.Checked) {
                    switch (generalAction.Type) {
                        case actionTypes.TYPE_STANDARD_GENERAL: this._initStandardGeneralAction(generalAction);
                            break;
                        case actionTypes.TYPE_DYNAMIC_GENERAL: this._initDynamicGeneralAction(generalAction);
                            break;
                        default: break;
                    }
                }
            });
        }

        this.generalActionControls.temporaryEditControl = new TemporaryEditControl(this.mapId, this.mapContainer, this.resourcesHandler, this.classId);
        this.generalActionControls.editControl.init();

        this.generalActionControls.snapControl = new SnapControl(this.resourcesHandler, this.layerSettingsHandler, document.getElementById(this.snapToolbarWrapper), this.rootURL, this.classId, this.mapControl);
        this.generalActionControls.snapControl.init();

        if ($('.toolbar-selection').length == 0) {
            let selectionToolbarContainer = document.getElementById(this.selectionToolbarWrapper);
            $(selectionToolbarContainer).append('<div class="map-toolbar toolbar-selection shadow-4" style="display:none; left: 3.7rem;  right: unset; width: fit-content;"></div>');
            $(selectionToolbarContainer).find(".toolbar-selection").append(`<ul class="map-toolbar-selected-items" style="display: none;">
                <li class="toolbar-selected-items-title">` + this.resourcesHandler.get('SelectTargetElement') + `</li>
                <li class="toolbar-selected-items-wrapper"></li>
            </ul>`);
        }

        $event.register(eventTypes.MAP_LOADED, this._getMapLoadedHandler(), this, this.classId);
    }

    _getMapLoadedHandler() {
        var handler = (eventName, data, sender) => {
            if (this.generalActionControls && this.generalActionControls.overviewControl) {
                this.generalActionControls.overviewControl.init();
            }
        };

        return handler;
    }

    startEdit(idLayer, features) {
        this.generalActionControls.editControl.startEdit(idLayer, null, null, null, features);
    }

    _initStandardGeneralAction(action) {
        switch (action.SubType) {
            case actionTypes.SUBTYPE_LEGEND: this._initLegendControl(action);
                break;
            case actionTypes.SUBTYPE_ZOOM: this._initZoomControl(action);
                break;
            case actionTypes.SUBTYPE_SCALE: this._initScaleControl(action);
                break;
            case actionTypes.SUBTYPE_OVERVIEW: this._initOverviewControl(action);
                break;
            case actionTypes.SUBTYPE_NAVIGATION_TOOLBAR: this._initNavigationToolbarControl(action);
                break;
            case actionTypes.SUBTYPE_SELECTION_TOOLBAR: this._initSelectionToolbarControl(action);
                break;
            case actionTypes.SUBTYPE_EXPORT_TOOLBAR: this._initExportToolbarControl(action);
                break;
            case actionTypes.SUBTYPE_MOUSE_POSITION: this._initMousePositionControl(action);
                break;
            case actionTypes.SUBTYPE_CRS_SWITCHER: this._initCoordinateReferenceSystemSwitcherControl(action);
                break;
            case actionTypes.SUBTYPE_GEOLOCATION: this._initGeolocationControl(action);
                break;
            case actionTypes.SUBTYPE_MEASUREMENT: this._initMeasurementControl(action);
                break;
            case actionTypes.SUBTYPE_DIMENSIONING: this._initDimensioningControl(action);
                break;
            case actionTypes.SUBTYPE_REDLINE: this._initRedlineControl(action);
                break;
            case actionTypes.SUBTYPE_JOIN_ANALYSIS: this._initJoinAnalysisControl(action);
                break;
            case actionTypes.SUBTYPE_BUFFER_ANALYSIS: this._initBufferAnalysisControl(action);
                break;
            case actionTypes.SUBTYPE_DEFAULT_PRINT: this._initPrintingAction(action);
                break;
            case actionTypes.SUBTYPE_QUICK_ADD: this._initQuickAddAction(action);
                break;
            case actionTypes.SUBTYPE_SWIPE: this._initSwipeControl(action);
                break;
            case actionTypes.SUBTYPE_TIMELINE: this._initTimelineControl(action);
                break;
            default: break;
        }
    }

    _initDynamicGeneralAction(action, parentId) {
        switch (action.SubType) {
            case actionTypes.SUBTYPE_PLUGIN: this._initPluginGeneralAction(action);
                break;
            case actionTypes.SUBTYPE_GROUP: this._initGroupGeneralAction(action);
                break;
            case actionTypes.SUBTYPE_PRINTING: this._initPrintingAction(action, parentId);
                break;
            case actionTypes.SUBTYPE_SPATIAL_SEARCH: this._initSpatialSearchAction(action, parentId);
                break;
            default: break;
        }
    }

    _initQuickAddAction(action) {
        let quickAddControl = new QuickAddControl(action, this.resourcesHandler, this.layerSettingsHandler, document.getElementById(this.mapMenuElementListId), this.rootURL, this.classId, this.mapControl, this.generalActionControls.editControl, this.quickAddLayers);
        this.generalActionControls.quickAddControl = quickAddControl;
        quickAddControl.init();
    }

    _initSpatialSearchAction(action, parentId) {
        this.mapContainer.append(this._getSpatialSearchWrapper(action.Id));

        let spatialSearchControl = new SpatialSearchControl(action, this.resourcesHandler, this.layerSettingsHandler, document.getElementById(this.spatialSearchWrapper + '-' + action.Id), this.rootURL, this.classId, this.mapControl, document.getElementById(this.mapMenuElementListId), this.quickSearches, parentId);
        if (this.generalActionControls.spatialSearch == null) {
            this.generalActionControls.spatialSearch = {};
        }

        this.generalActionControls.spatialSearch[action.Id] = spatialSearchControl;
        spatialSearchControl.init();
    }

    _initPrintingAction(action, parentId) {
        if (action.Content == null) {
            action.Content = '{"pageType": "A4", "template": "", "pageOrientation": "Portrait"}';
        }
        let printingControl = new PrintingControl(action, this.resourcesHandler, this.layerSettingsHandler, document.getElementById(this.mapMenuElementListId), this.rootURL, this.classId, this.mapControl, this.actionWrapper, parentId);
        if (this.generalActionControls.printing == null) {
            this.generalActionControls.printing = {};
        }

        this.generalActionControls.printing[action.Id] = printingControl;
        printingControl.init();
    }

    _initPluginGeneralAction(action) {
        if (window[action.Content] != null) {
            let plugin = new window[action.Content](this.rootURL, document.getElementById(this.mapMenuElementListId),
                this.mapControl, this.resourcesHandler, this.classId, action, this.actionWrapper);
            this.pluginControls[action.Id] = plugin;
        }
    }

    _initGroupGeneralAction(action) {
        document.getElementById(this.mapMenuElementListId).append(this._getActionButtonTemplate(action));

        let elementId = 'map-action-' + this.classId + '-' + action.Id;
        $('#' + elementId).parent().append('<div class="dropdown-menu" id="group-map-action-' + action.Id + '" style="max-height:' + ($(window).height() * 0.5).toString() + 'px; overflow-y:auto; display: none; left: unset; bottom: unset; top: unset; position: fixed; right: 0; margin-right: 4.5rem; top: unset;"></div>');

        document.getElementById(elementId).addEventListener('click', this._groupButtonClickHandler());

        if (action.Items && action.Items.length > 0) {
            action.Items.forEach(item => {
                this._initDynamicGeneralAction(item, 'group-map-action-' + action.Id);
            });
        }
    }

    _groupButtonClickHandler() {
        return (evt) => {
            if ($(evt.currentTarget).parent().find('.dropdown-menu').css('display') == 'none') {
                let height = $(evt.currentTarget).parent().find('.dropdown-menu').height() + 10;

                $(evt.currentTarget).parent().find('.dropdown-menu').css('margin-top', '-' + height + 'px');
                $(evt.currentTarget).parent().find('.dropdown-menu').css('display', 'block');
            } else {
                $(evt.currentTarget).parent().find('.dropdown-menu').css('display', 'none');
            }
        };
    }

    _getActionButtonTemplate(action) {
        let elementId = 'map-action-' + this.classId + '-' + action.Id;
        let div = document.createElement('div');
        div.innerHTML = `<li>
                            <a class="btn map-menu-item" id="` + elementId + `" title="` + this._getTitle(action) + `">
                                <i class="` + action.Icon + `"></i>
                            </a>
                        </li>`;
        return div.firstChild;
    }

    _getTitle(action) {
        if (action.Title != null && action.Title != '') {
            return action.Title;
        }

        return this.resourcesHandler.get('SubType_' + action.SubType);
    }

    _initLegendControl(action) {
        let legendControl = new LegendControl(action, this.resourcesHandler, this.layerSettingsHandler, document.getElementById(this.mapMenuElementListId),
            this.rootURL, this.classId, this.mapId, this.chartControl, this.styleHandler, this.mapControl);
        this.generalActionControls.legendControl = legendControl;
        legendControl.init();
    }

    _initZoomControl(action) {
        let zoomControl = new ZoomControl(action, this.resourcesHandler, this.layerSettingsHandler, document.getElementById(this.zoomWrapper), this.rootURL, this.classId, this.mapControl);
        this.generalActionControls.zoomControl = zoomControl;
        zoomControl.init();
    }

    _initScaleControl(action) {
        let scaleControl = new ScaleControl(action, this.resourcesHandler, this.layerSettingsHandler, document.getElementById(this.scaleWrapper), this.rootURL, this.classId, this.mapControl);
        this.generalActionControls.scaleControl = scaleControl;
        scaleControl.init();
    }

    _initOverviewControl(action) {
        let overviewControl = new OverviewControl(action, this.resourcesHandler, this.layerSettingsHandler, null, this.rootURL, this.classId, this.mapControl);
        this.generalActionControls.overviewControl = overviewControl;
        //overviewControl.init();
    }

    _initMousePositionControl(action) {
        let scale = this.generalActionSettingsHandler.settings.find(x => x.SubType == actionTypes.SUBTYPE_SCALE);
        let crsSwitcher = this.generalActionSettingsHandler.settings.find(x => x.SubType == actionTypes.SUBTYPE_CRS_SWITCHER);

        let siblingsBefore = 0;

        if (scale != null) {
            siblingsBefore++;
        }

        if (crsSwitcher != null) {
            siblingsBefore++;
        }

        let mousePositionControl = new MousePositionControl(action, this.resourcesHandler, this.layerSettingsHandler, document.getElementById(this.mousePositionWrapper), this.rootURL, this.classId, this.mapControl, siblingsBefore);
        this.generalActionControls.mousePositionControl = mousePositionControl;
        mousePositionControl.init();
    }

    _initCoordinateReferenceSystemSwitcherControl(action) {
        let scale = this.generalActionSettingsHandler.settings.find(x => x.SubType == actionTypes.SUBTYPE_SCALE);

        let siblingsBefore = 0;

        if (scale != null) {
            siblingsBefore++;
        }

        let coordinateReferenceSystemSwitcherControl = new CoordinateReferenceSystemSwitcherControl(action, this.resourcesHandler, this.layerSettingsHandler, document.getElementById(this.crsSwitcherWrapper), this.rootURL, this.classId, this.mapControl, siblingsBefore);
        this.generalActionControls.coordinateReferenceSystemSwitcherControl = coordinateReferenceSystemSwitcherControl;
        coordinateReferenceSystemSwitcherControl.init();
    }

    _initNavigationToolbarControl(action) {
        let navigationToolbarControl = new NavigationToolbarControl(action, this.resourcesHandler, this.layerSettingsHandler, document.getElementById(this.navigationToolbarWrapper), this.rootURL, this.classId, this.mapControl);
        this.generalActionControls.navigationToolbarControl = navigationToolbarControl;
        navigationToolbarControl.init();
    }

    _initSelectionToolbarControl(action) {
        let selectionToolbarControl = new SelectionToolbarControl(action, this.resourcesHandler, this.layerSettingsHandler, document.getElementById(this.selectionToolbarWrapper), this.rootURL, this.classId, this.mapControl, {
            pixelTolerance: 25,
            edge: true,
            vertex: true,
            intersection: true
        });
        this.generalActionControls.selectionToolbarControl = selectionToolbarControl;
        selectionToolbarControl.init();
    }

    _initExportToolbarControl(action) {
        let exportToolbarControl = new ExportToolbarControl(action, this.resourcesHandler, this.layerSettingsHandler, document.getElementById(this.exportToolbarWrapper), this.rootURL, this.classId, this.mapControl, {
            pixelTolerance: 25,
            edge: true,
            vertex: true,
            intersection: true
        }, document.getElementById(this.mapMenuElementListId), this.actionWrapper);
        this.generalActionControls.exportToolbarControl = exportToolbarControl;
        exportToolbarControl.init();
    }

    _initGeolocationControl(action) {
        let geolocationControl = new GeolocationControl(action, this.resourcesHandler, this.layerSettingsHandler, document.getElementById(this.mapMenuElementListId), this.rootURL, this.classId, this.mapControl);
        this.generalActionControls.geolocationControl = geolocationControl;
        geolocationControl.init();
    }

    _initMeasurementControl(action) {
        let measurementControl = new MeasurementControl(action, this.resourcesHandler, this.layerSettingsHandler, document.getElementById(this.mapMenuElementListId), this.rootURL, this.classId, this.mapControl, document.getElementById(this.featureToolbarWrapper));
        this.generalActionControls.measurementControl = measurementControl;
        measurementControl.init();
    }

    _initTimelineControl(action) {
        let timelineControl = new TimelineControl(action, this.resourcesHandler, this.layerSettingsHandler, document.getElementById(this.mapMenuElementListId), this.rootURL, this.classId, this.mapControl, document.getElementById(this.timelineWrapper));
        this.generalActionControls.timelineControl = timelineControl;
        timelineControl.init();
    }

    _initDimensioningControl(action) {
        let dimensioningControl = new DimensioningControl(action, this.resourcesHandler, this.layerSettingsHandler, document.getElementById(this.mapMenuElementListId), this.rootURL, this.classId, this.mapControl, document.getElementById(this.featureToolbarWrapper), {
            pixelTolerance: 25,
            edge: true,
            vertex: true,
            intersection: true
        });
        this.generalActionControls.dimensioningControl = dimensioningControl;
        dimensioningControl.init();
    }

    _initRedlineControl(action) {
        let redlineControl = new RedlineControl(action, this.resourcesHandler, this.layerSettingsHandler, document.getElementById(this.mapMenuElementListId), this.rootURL, this.classId, this.mapControl, document.getElementById(this.featureToolbarWrapper), {
            pixelTolerance: 25,
            edge: true,
            vertex: true,
            intersection: true
        });
        this.generalActionControls.redlineControl = redlineControl;
        redlineControl.init();
    }

    _initSwipeControl(action) {
        let swipeControl = new SwipeControl(action, this.resourcesHandler, this.layerSettingsHandler, document.getElementById(this.mapMenuElementListId), this.rootURL, this.classId, this.mapControl, document.getElementById(this.swipeWrapper));
        this.generalActionControls.swipeControl = swipeControl;
        swipeControl.init();
    }

    _initJoinAnalysisControl(action) {
        let joinAnalysisControl = new JoinAnalysisControl(action, this.resourcesHandler, this.layerSettingsHandler, document.getElementById(this.mapMenuElementListId), this.rootURL, this.classId, this.mapControl, this.actionWrapper);
        this.generalActionControls.joinAnalysisControl = joinAnalysisControl;
        joinAnalysisControl.init();
    }

    _initBufferAnalysisControl(action) {
        let bufferAnalysisControl = new BufferAnalysisControl(action, this.resourcesHandler, this.layerSettingsHandler, document.getElementById(this.mapMenuElementListId), this.rootURL, this.classId, this.mapControl, this.actionWrapper);
        this.generalActionControls.bufferAnalysisControl = bufferAnalysisControl;
        bufferAnalysisControl.init();
    }

    _getActionListTemplate() {
        let div = document.createElement('div');
        div.innerHTML = `<div class='map-menu' id="` + this.mapMenuElementId + `">
                            <ul id="` + this.mapMenuElementListId + `">
                            </ul>
                        </div>`;
        return div.firstChild;
    }

    _getChartWrapper() {
        let div = document.createElement('div');
        div.innerHTML = `<div class='charts-wrapper' id="` + this.chartsWrapper + `">
                        </div>`;
        return div.firstChild;
    }

    _getActionWrapper() {
        let div = document.createElement('div');
        div.innerHTML = `<div class='action-wrapper' id="` + this.actionWrapper + `">
                        </div>`;
        return div.firstChild;
    }

    _getZoomWrapper() {
        let div = document.createElement('div');
        div.innerHTML = `<div class='zoom-wrapper' id="` + this.zoomWrapper + `">
                        </div>`;
        return div.firstChild;
    }

    _getScaleWrapper() {
        let div = document.createElement('div');
        div.innerHTML = `<div class='scale-wrapper' id="` + this.scaleWrapper + `">
                        </div>`;
        return div.firstChild;
    }

    _getMousePositionWrapper() {
        let div = document.createElement('div');
        div.innerHTML = `<div class='mouse-position-wrapper' id="` + this.mousePositionWrapper + `">
                        </div>`;
        return div.firstChild;
    }

    _getCrsSwitcherWrapper() {
        let div = document.createElement('div');
        div.innerHTML = `<div class='crs-switcher-wrapper' id="` + this.crsSwitcherWrapper + `">
                        </div>`;
        return div.firstChild;
    }

    _getNavigationToolbarWrapper() {
        let div = document.createElement('div');
        div.innerHTML = `<div class='navigation-toolbar-wrapper' id="` + this.navigationToolbarWrapper + `">
                        </div>`;
        return div.firstChild;
    }

    _getSelectionToolbarWrapper() {
        let div = document.createElement('div');
        div.innerHTML = `<div class='selection-toolbar-wrapper' id="` + this.selectionToolbarWrapper + `">
                        </div>`;
        return div.firstChild;
    }

    _getSpatialSearchWrapper(actionId) {
        let div = document.createElement('div');
        div.innerHTML = `<div class='spatial-search-wrapper' id="` + this.spatialSearchWrapper + `-` + actionId + `" style="display:none;">
                        </div>`;
        return div.firstChild;
    }

    _getExportToolbarWrapper() {
        let div = document.createElement('div');
        div.innerHTML = `<div class='export-toolbar-wrapper' id="` + this.exportToolbarWrapper + `">
                        </div>`;
        return div.firstChild;
    }

    _getFeatureToolbarWrapper() {
        let div = document.createElement('div');
        div.innerHTML = `<div class='feature-toolbar-wrapper' id="` + this.featureToolbarWrapper + `">
                        </div>`;
        return div.firstChild;
    }

    _getSwipeWrapper() {
        let div = document.createElement('div');
        div.innerHTML = `<div class='swipe-wrapper' id="` + this.swipeWrapper + `">
                        </div>`;
        return div.firstChild;
    }

    _getSnapToolbarWrapper() {
        let div = document.createElement('div');
        div.innerHTML = `<div class='snap-toolbar-wrapper' id="` + this.snapToolbarWrapper + `">
                        </div>`;
        return div.firstChild;
    }

    _getTimelineWrapper() {
        let div = document.createElement('div');
        div.innerHTML = `<div class='timeline-wrapper' id="` + this.timelineWrapper + `">
                        </div>`;
        return div.firstChild;
    }
}